module.exports = __webpack_public_path__ + "static/img/EEDP3.90473c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/schoolEnrollment/EEDP3.jpg
// module id = AITR
// module chunks = 1